// ─── Constants ───────────────────────────────────────────────────────────────
const SHEETS_URL  = "https://script.google.com/macros/s/AKfycbyRwM-emlALOmcthoXRpGqfqFeuDCMk-fTnGzT89uJUeYYGs-RMTdNOr3lkrCF5LA3llA/exec";
const SHOPIFY_MCP = "https://setup.shopify.com/mcp";
const GUSTO_MCP   = "https://mcp.api.gusto.com/anthropic";
const MODEL = "claude-sonnet-4-5";

// ─── State ───────────────────────────────────────────────────────────────────
let shopifyOrders    = [];
let shopifyCustomers = [];
let shopifyProducts  = [];
let shopifyLocations = {};
let waitlistEntries  = [];
let channelGoals = {
  mkt: {name:"MKT Heights", target:85000, current:0},
  bel: {name:"Bellaire",    target:70000, current:0},
  onl: {name:"Online",      target:55000, current:0},
  oth: {name:"Others",      target:20000, current:0}
};
let TASKS = {todo:[], inprog:[], done:[]};

// ─── Helpers ─────────────────────────────────────────────────────────────────
const AVCOLORS = ["#e49780","#7A8775","#c9a090","#a4ad9f","#d4b8ae","#8fa389","#c08070","#6b8064"];
const CH_COLORS = {mkt:"#e49780", bel:"#7A8775", onl:"#c9a090", oth:"#a4ad9f"};
const CH_BADGE  = {mkt:"badge-mkt", bel:"badge-bel", onl:"badge-onl", oth:"badge-oth"};
const CH_LABELS = {mkt:"MKT Heights", bel:"Bellaire", onl:"Online", oth:"Others"};

function ini(n){ if(!n)return"?"; const p=n.trim().split(" "); return(p[0][0]+(p[1]?p[1][0]:"")).toUpperCase(); }
function avCol(i){ return AVCOLORS[i%AVCOLORS.length]; }
function fmt$(n){ return "$"+Number(n).toLocaleString("en-US",{maximumFractionDigits:0}); }
function fmtDate(d){ if(!d)return"—"; return new Date(d).toLocaleDateString("en-US",{month:"short",day:"numeric"}); }
function today(){ return new Date().toLocaleDateString("en-US",{month:"long",year:"numeric"}); }

// ─── Navigation ──────────────────────────────────────────────────────────────
function nav(id, el){
  document.querySelectorAll('.page').forEach(p=>p.classList.remove('active'));
  document.querySelectorAll('.nav-item').forEach(n=>n.classList.remove('active'));
  document.getElementById('page-'+id).classList.add('active');
  el.classList.add('active');
}

// ─── Claude API ──────────────────────────────────────────────────────────────
async function callClaude(prompt, mcpServers){
  const payload = {model:MODEL, max_tokens:2000, messages:[{role:"user",content:prompt}]};
  if(mcpServers) payload.mcp_servers = mcpServers;
  const r = await fetch("https://dainty-hare-75.beautyshop.deno.net", {
    method:"POST",
    headers:{"Content-Type":"application/json"},
    body: JSON.stringify(payload)
  });
  if(!r.ok) throw new Error("Proxy error "+r.status);
  return r.json();
}

function extractJSON(data, preferKey){
  const txt = data.content.filter(b=>b.type==="text").map(b=>b.text).join("\n");
  // Try array first
  const am = txt.match(/\[[\s\S]{2,}\]/);
  if(am){try{const p=JSON.parse(am[0]);if(Array.isArray(p))return p;}catch{}}
  // Try object
  const om = txt.match(/\{[\s\S]{2,}\}/);
  if(om){try{
    const p=JSON.parse(om[0]);
    if(preferKey&&p[preferKey]) return p[preferKey];
    return p;
  }catch{}}
  // Try tool result blocks
  for(const b of data.content){
    if(b.type==="mcp_tool_result"){
      const t = b.content?.[0]?.text||"";
      try{
        const p=JSON.parse(t);
        if(Array.isArray(p)) return p;
        // GraphQL edges
        const edges = p?.data?.orders?.edges
          || p?.data?.customers?.edges
          || p?.data?.products?.edges
          || p?.data?.locations?.edges;
        if(edges) return edges.map(e=>e.node);
        if(preferKey&&p[preferKey]) return p[preferKey];
        return p;
      }catch{}
    }
  }
  return null;
}

// ─── Google Sheets: Waitlist ──────────────────────────────────────────────────
async function sheetsGet(){
  try{
    const r = await fetch(SHEETS_URL+"?sheet=Waitlist&nocache="+Date.now());
    const json = await r.json();
    if(json.success && json.data){
      waitlistEntries = json.data.filter(e=>e.customerName);
      renderWaitlist();
    }
  }catch(e){ console.error("Sheets read",e); }
}

async function sheetsAdd(entry){
  try{ await fetch(SHEETS_URL,{method:"POST",body:JSON.stringify({action:"add",...entry})}); }
  catch(e){ console.error("Sheets add",e); }
}

async function sheetsUpdate(customerName,product,status){
  try{ await fetch(SHEETS_URL,{method:"POST",body:JSON.stringify({action:"update",customerName,product,status})}); }
  catch(e){ console.error("Sheets update",e); }
}

async function sheetsDelete(customerName,product){
  try{ await fetch(SHEETS_URL,{method:"POST",body:JSON.stringify({action:"delete",customerName,product})}); }
  catch(e){ console.error("Sheets delete",e); }
}

// ─── Google Sheets: Goals ─────────────────────────────────────────────────────
async function loadGoals(){
  try{
    const r = await fetch(SHEETS_URL+"?sheet=Goals&nocache="+Date.now());
    const json = await r.json();
    if(json.success && json.data && json.data.length){
      json.data.forEach(g=>{
        const key = (g.channel||"").toLowerCase().slice(0,3);
        const ch = key==="mkt"?"mkt":key==="bel"?"bel":key==="onl"?"onl":key==="oth"?"oth":null;
        if(ch && g.target) channelGoals[ch].target = parseInt(g.target)||channelGoals[ch].target;
      });
    }
  }catch(e){ console.error("Goals load",e); }
}

async function saveGoalsToSheets(){
  try{
    await fetch(SHEETS_URL,{method:"POST",body:JSON.stringify({
      action:"save_goals",
      goals:Object.entries(channelGoals).map(([ch,g])=>({channel:ch,name:g.name,target:g.target}))
    })});
  }catch(e){ console.error("Goals save",e); }
}

// ─── Google Sheets: Tasks ─────────────────────────────────────────────────────
async function loadTasks(){
  document.getElementById('col-todo').innerHTML='<div class="loading-msg">Loading…</div>';
  try{
    const r = await fetch(SHEETS_URL+"?sheet=Tasks&nocache="+Date.now());
    const json = await r.json();
    if(json.success && json.data && json.data.length){
      TASKS = {todo:[], inprog:[], done:[]};
      json.data.filter(t=>t.title).forEach(t=>{
        const s = (t.status||"todo").toLowerCase().replace(/\s/g,"");
        if(s==="done"||s==="complete") TASKS.done.push(t);
        else if(s==="inprogress"||s==="inprog") TASKS.inprog.push(t);
        else TASKS.todo.push(t);
      });
    }
  }catch(e){ console.error("Tasks load",e); }
  renderProjects();
}

async function saveTask(task,action){
  try{ await fetch(SHEETS_URL,{method:"POST",body:JSON.stringify({action:"task_"+action,...task})}); }
  catch(e){ console.error("Task save",e); }
}

async function moveTask(col,idx,newStatus){
  const task = TASKS[col][idx];
  task.status = newStatus;
  TASKS[col].splice(idx,1);
  if(newStatus==="done") TASKS.done.unshift(task);
  else if(newStatus==="inprogress") TASKS.inprog.unshift(task);
  else TASKS.todo.unshift(task);
  renderProjects();
  await saveTask(task,"update");
}

async function deleteTask(col,idx){
  if(!confirm("Remove this task?")) return;
  const task = TASKS[col][idx];
  TASKS[col].splice(idx,1);
  renderProjects();
  await saveTask(task,"delete");
}

// ─── Shopify: Orders ──────────────────────────────────────────────────────────
async function loadOrders(){
  try{
    const data = await callClaude(
      `Use the Shopify MCP to:
1. Fetch all store locations (id and name).
2. Fetch the 30 most recent orders, including which location each order came from.
Return ONLY this JSON structure, no markdown or explanation:
{"locations":[{"id":"loc1","name":"MKT Heights"},{"id":"loc2","name":"Bellaire"},{"id":"loc3","name":"Online Store"}],
"orders":[{"name":"#1001","customer":"Jane Doe","email":"j@d.com","total":"95.00","financial_status":"paid","fulfillment_status":"fulfilled","created_at":"2026-06-01T10:00:00Z","location_id":"loc1","location_name":"MKT Heights"}]}`,
      [{type:"url", url:SHOPIFY_MCP, name:"shopify"}]
    );
    const txt = data.content.filter(b=>b.type==="text").map(b=>b.text).join("\n");
    const om = txt.match(/\{[\s\S]{2,}\}/);
    let parsed = null;
    if(om){try{parsed=JSON.parse(om[0]);}catch{}}
    if(!parsed) parsed = extractJSON(data,"orders");

    if(parsed?.locations){
      parsed.locations.forEach(l=>{ shopifyLocations[l.id]=l.name; });
    }
    let orders = parsed?.orders || (Array.isArray(parsed)?parsed:[]);
    if(!orders.length) orders = extractJSON(data) || [];
    if(!Array.isArray(orders)||!orders.length){
      console.warn("No real orders returned, using fallback");
      orders = [];
    }
    // Tag location names
    orders = orders.map(o=>{
      if(!o.location_name && o.location_id && shopifyLocations[o.location_id])
        o.location_name = shopifyLocations[o.location_id];
      if(!o.location_name) o.location_name = inferLocation(o);
      return o;
    });
    shopifyOrders = orders;
    renderOrders(orders);
  }catch(e){
    console.error("Orders error",e);
    renderOrders([]);
  }
}

function inferLocation(o){
  const loc = ((o.location_name||"")+(o.location||"")).toLowerCase();
  if(loc.includes("height")||loc.includes("mkt")) return "MKT Heights";
  if(loc.includes("bellair")) return "Bellaire";
  if(loc.includes("online")||loc.includes("web")) return "Online";
  return null;
}

function getLocBadge(loc){
  if(!loc) return '<span class="badge badge-gray">—</span>';
  const l = loc.toLowerCase();
  if(l.includes("height")||l.includes("mkt")) return '<span class="badge badge-mkt">MKT Heights</span>';
  if(l.includes("bellair")) return '<span class="badge badge-bel">Bellaire</span>';
  if(l.includes("online")||l.includes("web")) return '<span class="badge badge-onl">Online</span>';
  return `<span class="badge badge-gray">${loc}</span>`;
}

function finBadge(s){
  if(!s)return"badge-gray";
  const l=s.toLowerCase();
  if(l==="paid")return"badge-green";
  if(l.includes("pending"))return"badge-amber";
  if(l.includes("refund")||l.includes("void"))return"badge-rose";
  return"badge-gray";
}

function renderOrders(orders){
  const total = orders.reduce((s,o)=>s+parseFloat(o.total||0),0);
  const unf   = orders.filter(o=>(o.fulfillment_status||"").toLowerCase()==="unfulfilled").length;
  const aov   = orders.length ? total/orders.length : 0;
  const setEl = (id,v)=>{ const el=document.getElementById(id); if(el) el.textContent=v; };
  setEl('ord-total', fmt$(Math.round(total)));
  setEl('ord-count', orders.length);
  setEl('ord-aov',   fmt$(Math.round(aov)));
  setEl('ord-unf',   unf);
  setEl('m-rev',     fmt$(Math.round(total)));
  setEl('m-ord',     orders.length);
  setEl('m-rev-sub', 'from '+orders.length+' orders');
  setEl('m-ord-sub', unf+' unfulfilled');

  const listEl = document.getElementById('orders-list');
  if(listEl){
    if(!orders.length){
      listEl.innerHTML='<div class="loading-msg">No orders returned from Shopify. Check MCP connection.</div>';
    } else {
      listEl.innerHTML = orders.map(o=>`
        <div class="order-row">
          <span class="order-num">${o.name||"—"}</span>
          <span class="order-name">${o.customer||o.email||"Guest"}</span>
          ${getLocBadge(o.location_name)}
          <span class="badge ${finBadge(o.financial_status)}">${o.financial_status||"—"}</span>
          <span class="order-total">${fmt$(o.total||0)}</span>
          <span style="font-size:11px;color:var(--text3);font-family:var(--mono)">${fmtDate(o.created_at)}</span>
        </div>`).join("");
    }
  }
  const dashEl = document.getElementById('dash-orders');
  if(dashEl){
    dashEl.innerHTML = orders.slice(0,5).map(o=>`
      <div class="order-row">
        <span class="order-num">${o.name}</span>
        <span class="order-name">${o.customer||"Guest"}</span>
        ${getLocBadge(o.location_name)}
        <span class="order-total">${fmt$(o.total||0)}</span>
      </div>`).join("") || '<div class="loading-msg">No orders yet</div>';
  }
  updateGoalsFromRevenue(orders);
}

// ─── Shopify: Customers ───────────────────────────────────────────────────────
async function loadCustomers(){
  try{
    const data = await callClaude(
      `Use the Shopify MCP to fetch the 50 most recent customers.
Return ONLY a JSON array, no markdown:
[{"id":"1","first_name":"Jane","last_name":"Doe","email":"jane@example.com","orders_count":3}]`,
      [{type:"url", url:SHOPIFY_MCP, name:"shopify"}]
    );
    const c = extractJSON(data);
    shopifyCustomers = (c&&Array.isArray(c)) ? c : [];
  }catch(e){ console.error("Customers",e); shopifyCustomers=[]; }
}

// ─── Shopify: Products ────────────────────────────────────────────────────────
async function loadProducts(){
  try{
    const data = await callClaude(
      `Use the Shopify MCP to fetch the 40 active products.
Return ONLY a JSON array, no markdown:
[{"id":"p1","title":"Product Name","variants":[{"id":"v1","title":"Variant"}],"inventory_quantity":5}]`,
      [{type:"url", url:SHOPIFY_MCP, name:"shopify"}]
    );
    const p = extractJSON(data);
    shopifyProducts = (p&&Array.isArray(p)) ? p : [];
  }catch(e){ console.error("Products",e); shopifyProducts=[]; }
}

// ─── Goals ────────────────────────────────────────────────────────────────────
function updateGoalsFromRevenue(orders){
  const locationMap = {
    "mkt heights":"mkt","heights":"mkt","mkt":"mkt",
    "bellaire":"bel","bellair":"bel",
    "online":"onl","online store":"onl","web":"onl"
  };
  Object.keys(channelGoals).forEach(ch=>{ channelGoals[ch].current=0; });
  let unassigned = 0;
  orders.forEach(o=>{
    const val    = parseFloat(o.total||0);
    const locRaw = (o.location_name||"").toLowerCase().trim();
    let matched  = false;
    for(const [key,ch] of Object.entries(locationMap)){
      if(locRaw.includes(key)){ channelGoals[ch].current+=val; matched=true; break; }
    }
    if(!matched) unassigned += val;
  });
  channelGoals["oth"].current += Math.round(unassigned);
  Object.keys(channelGoals).forEach(ch=>{ channelGoals[ch].current=Math.round(channelGoals[ch].current); });
  renderGoals();
  renderDashGoals();
}

function renderGoals(){
  const panels = document.getElementById('goals-panels');
  if(!panels) return;
  const channels = ['all','mkt','bel','onl','oth'];
  let html = '';
  channels.forEach(ch=>{
    const isAll = ch==='all';
    html += `<div class="channel-panel ${isAll?'active':''}" id="panel-${ch}">`;
    if(isAll){
      html += '<div style="display:grid;grid-template-columns:1fr 1fr;gap:16px">';
      Object.entries(channelGoals).forEach(([k,g])=>{ html+=channelGoalCard(k,g,false); });
      html += '</div>';
    } else {
      html += channelGoalCard(ch,channelGoals[ch],true);
    }
    html += '</div>';
  });
  panels.innerHTML = html;
}

function channelGoalCard(ch,g,expanded){
  const pct   = Math.min(100,Math.round(g.current/g.target*100));
  const badge = pct>=80?"badge-green":pct>=50?"badge-amber":"badge-rose";
  const color = CH_COLORS[ch];
  let extraHtml = '';
  if(expanded){
    const extra=[
      {name:"Transactions", current:0, target:30},
      {name:"New clients",  current:0, target:12},
      {name:"Avg ticket",   current:g.current&&shopifyOrders.filter(o=>{
        const l=(o.location_name||"").toLowerCase();
        return ch==="mkt"?l.includes("height"):ch==="bel"?l.includes("bellair"):ch==="onl"?l.includes("online"):true;
      }).length ? Math.round(g.current/Math.max(1,shopifyOrders.filter(o=>{
        const l=(o.location_name||"").toLowerCase();
        return ch==="mkt"?l.includes("height"):ch==="bel"?l.includes("bellair"):ch==="onl"?l.includes("online"):true;
      }).length)):0, target:150, fmt:fmt$},
    ];
    // Count real transactions per location
    const locOrders = shopifyOrders.filter(o=>{
      const l=(o.location_name||"").toLowerCase();
      return ch==="mkt"?l.includes("height"):ch==="bel"?l.includes("bellair"):ch==="onl"?l.includes("online"):!l.includes("height")&&!l.includes("bellair")&&!l.includes("online");
    });
    extra[0].current = locOrders.length;
    extra[2].current = locOrders.length ? Math.round(g.current/locOrders.length):0;

    extra.forEach(eg=>{
      const ep = Math.min(100,eg.target?Math.round(eg.current/eg.target*100):0);
      const cur = eg.fmt?eg.fmt(eg.current):eg.current;
      const tgt = eg.fmt?eg.fmt(eg.target):eg.target;
      extraHtml += `<div class="goal-row">
        <div class="goal-header"><span class="goal-name">${eg.name}</span><span class="goal-meta">${cur} / ${tgt}</span></div>
        <div class="progress-track"><div class="progress-fill" style="width:${ep}%;background:${color}"></div></div>
      </div>`;
    });
  }
  return `<div class="card" style="border-top:3px solid ${color}">
    <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:14px">
      <span style="font-family:var(--serif);font-size:17px;font-weight:500">${g.name}</span>
      <span class="badge ${badge}">${pct}%</span>
    </div>
    <div class="goal-row">
      <div class="goal-header"><span class="goal-name">Revenue</span><span class="goal-meta">${fmt$(g.current)} / ${fmt$(g.target)}</span></div>
      <div class="progress-track"><div class="progress-fill" style="width:${pct}%;background:${color}"></div></div>
    </div>${extraHtml}
  </div>`;
}

function renderDashGoals(){
  const el = document.getElementById('dash-goals');
  if(!el) return;
  el.innerHTML = Object.entries(channelGoals).map(([ch,g])=>{
    const pct = Math.min(100,Math.round(g.current/g.target*100));
    return `<div style="margin-bottom:12px">
      <div style="display:flex;justify-content:space-between;margin-bottom:5px">
        <span style="font-size:12px;font-weight:500">${g.name}</span>
        <span style="font-size:11px;font-family:var(--mono);color:var(--text3)">${fmt$(g.current)} / ${fmt$(g.target)}</span>
      </div>
      <div class="progress-track"><div class="progress-fill" style="width:${pct}%;background:${CH_COLORS[ch]}"></div></div>
    </div>`;
  }).join("");
}

function showChannel(ch,el){
  document.querySelectorAll('.ch-tab').forEach(t=>{ t.className='ch-tab'; });
  el.classList.add('active-'+ch);
  document.querySelectorAll('.channel-panel').forEach(p=>p.classList.remove('active'));
  document.getElementById('panel-'+ch).classList.add('active');
}

function openGoalEditor(){
  document.getElementById('goal-editor-fields').innerHTML = Object.entries(channelGoals).map(([ch,g])=>`
    <div class="form-row">
      <label class="form-label">${g.name} — monthly target</label>
      <input class="form-input" id="goal-input-${ch}" type="number" value="${g.target}">
    </div>`).join("");
  document.getElementById('modal-goals').classList.add('open');
}

async function saveGoals(){
  Object.keys(channelGoals).forEach(ch=>{
    const v = parseInt(document.getElementById('goal-input-'+ch).value)||channelGoals[ch].target;
    channelGoals[ch].target = v;
  });
  renderGoals(); renderDashGoals(); closeModal('modal-goals');
  await saveGoalsToSheets();
}

// ─── Waitlist ─────────────────────────────────────────────────────────────────
function renderWaitlist(){
  const avail   = waitlistEntries.filter(e=>e.status==='available').length;
  const waiting = waitlistEntries.filter(e=>e.status==='waiting').length;
  const setEl   = (id,v)=>{ const el=document.getElementById(id); if(el) el.textContent=v; };
  setEl('wlm-total',   waitlistEntries.length);
  setEl('wlm-avail',   avail);
  setEl('wlm-waiting', waiting);
  setEl('wl-count-tag',waitlistEntries.length+' entries');
  setEl('m-wl',        waitlistEntries.length);
  setEl('m-wl-sub',    avail+' available now');
  setEl('m-alerts',    avail);

  const alertHtml = waitlistEntries.filter(e=>e.status==='available').map(e=>`
    <div class="alert-banner">
      <span style="font-size:20px">🌸</span>
      <div style="flex:1">
        <div class="alert-banner-title">${e.product} is back in stock!</div>
        <div class="alert-banner-sub">${e.customerName} · ${CH_LABELS[e.store]||e.store}</div>
      </div>
      <span class="badge badge-green">Ready to notify</span>
    </div>`).join("");
  ['dash-alerts','wl-alerts'].forEach(id=>{ const el=document.getElementById(id); if(el) el.innerHTML=alertHtml; });

  const alertEl = document.getElementById('wl-nav-alert');
  if(alertEl){ alertEl.textContent=avail; alertEl.style.display=avail>0?'inline-block':'none'; }

  const body = document.getElementById('wl-body');
  if(!body) return;
  if(!waitlistEntries.length){
    body.innerHTML=`<tr><td colspan="6" style="text-align:center;color:var(--text3);padding:28px;font-size:13px">
      No customers on the waitlist yet.<br><span style="font-size:12px">Tap "+ Add customer" to get started.</span>
    </td></tr>`;
    return;
  }
  body.innerHTML = waitlistEntries.map((e,i)=>{
    const sb = e.status==='available'?'badge-green':e.status==='notified'?'badge-amber':'badge-gray';
    const sl = e.status==='available'?'Available':e.status==='notified'?'Notified':'Waiting';
    return `<tr>
      <td><div style="display:flex;align-items:center;gap:8px">
        <div class="av" style="width:28px;height:28px;font-size:11px;font-weight:600;background:${avCol(i)};color:#fff">${ini(e.customerName)}</div>
        <div><div style="font-size:13px;font-weight:500">${e.customerName}</div><div style="font-size:11px;color:var(--text3)">${e.customerEmail||""}</div></div>
      </div></td>
      <td><div style="font-size:13px;font-weight:500">${e.product}</div>${e.notes?`<div style="font-size:11px;color:var(--text3)">${e.notes}</div>`:""}</td>
      <td><span class="badge ${CH_BADGE[e.store]||'badge-gray'}">${CH_LABELS[e.store]||e.store}</span></td>
      <td style="font-size:12px;color:var(--text3);font-family:var(--mono)">${e.added}</td>
      <td><span class="badge ${sb}">${sl}</span></td>
      <td><div style="display:flex;gap:6px">
        ${e.status==='available'?`<button class="btn btn-sm btn-accent" onclick="notifyCustomer(${i})">Notify</button>`:''}
        <button class="btn btn-sm" onclick="removeWaitlist(${i})">✕</button>
      </div></td>
    </tr>`;
  }).join("");
}

function openAddWaitlist(){ document.getElementById('modal-wl').classList.add('open'); }
function closeModal(id){ document.getElementById(id).classList.remove('open'); }
function clearCustomer(){
  ['cust-id','cust-name-val','cust-email-val'].forEach(id=>{ const el=document.getElementById(id); if(el) el.value=''; });
  const cs=document.getElementById('cust-search'); if(cs) cs.value='';
  const scr=document.getElementById('selected-customer-row'); if(scr) scr.style.display='none';
  const cr=document.getElementById('cust-results'); if(cr) cr.style.display='none';
}

function searchCustomers(q){
  const res = document.getElementById('cust-results');
  if(!q||q.length<2){ res.style.display='none'; return; }
  const matches = shopifyCustomers.filter(c=>
    `${c.first_name} ${c.last_name} ${c.email}`.toLowerCase().includes(q.toLowerCase())
  ).slice(0,6);
  if(!matches.length){ res.style.display='none'; return; }
  res.innerHTML = matches.map(c=>`
    <div class="customer-result-item" onclick="selectCustomer('${c.id}','${(c.first_name||'')} ${(c.last_name||'')}','${c.email||''}')">
      <div class="customer-result-name">${c.first_name||''} ${c.last_name||''}</div>
      <div class="customer-result-email">${c.email||''} · ${c.orders_count||0} orders</div>
    </div>`).join("");
  res.style.display='block';
}

function selectCustomer(id,name,email){
  document.getElementById('cust-id').value=id;
  document.getElementById('cust-name-val').value=name.trim();
  document.getElementById('cust-email-val').value=email;
  document.getElementById('cust-search').value='';
  document.getElementById('cust-results').style.display='none';
  document.getElementById('selected-customer-row').style.display='block';
  document.getElementById('sel-av').textContent=ini(name.trim());
  document.getElementById('sel-name').textContent=name.trim();
  document.getElementById('sel-email').textContent=email;
}

function searchProducts(q){
  const res = document.getElementById('product-results');
  if(!q||q.length<2){ res.style.display='none'; return; }
  const matches = shopifyProducts.filter(p=>p.title.toLowerCase().includes(q.toLowerCase())).slice(0,6);
  if(!matches.length){ res.style.display='none'; return; }
  res.innerHTML = matches.map(p=>`
    <div class="customer-result-item" onclick="selectProduct('${p.id}','${p.title}')">
      <div class="customer-result-name">${p.title}</div>
      <div class="customer-result-email">${(p.variants||[]).map(v=>v.title).join(", ")||"No variants"}</div>
    </div>`).join("");
  res.style.display='block';
}

function selectProduct(id,title){
  document.getElementById('wl-product').value=title;
  document.getElementById('wl-product-id').value=id;
  document.getElementById('product-results').style.display='none';
}

async function submitWaitlist(){
  const name      = document.getElementById('cust-name-val').value;
  const email     = document.getElementById('cust-email-val').value;
  const product   = document.getElementById('wl-product').value;
  const productId = document.getElementById('wl-product-id').value;
  const store     = document.getElementById('wl-store').value;
  const notes     = document.getElementById('wl-notes').value;
  if(!name){alert('Please select a customer.');return;}
  if(!product){alert('Please enter the product.');return;}
  const entry = {customerName:name,customerEmail:email,product,productId:productId||null,store,notes,
    added:new Date().toLocaleDateString("en-US",{month:"short",day:"numeric"}),status:'waiting'};
  waitlistEntries.unshift(entry);
  renderWaitlist();
  closeModal('modal-wl'); clearCustomer();
  document.getElementById('wl-product').value='';
  document.getElementById('wl-notes').value='';
  await sheetsAdd(entry);
  await sheetsGet();
}

async function notifyCustomer(i){
  const e = waitlistEntries[i];
  waitlistEntries[i].status='notified';
  renderWaitlist();
  await sheetsUpdate(e.customerName,e.product,'notified');
  await sheetsGet();
}

async function removeWaitlist(i){
  if(!confirm('Remove this entry?')) return;
  const e = waitlistEntries[i];
  waitlistEntries.splice(i,1);
  renderWaitlist();
  await sheetsDelete(e.customerName,e.product);
  await sheetsGet();
}

// ─── Inventory ────────────────────────────────────────────────────────────────
async function checkInventory(){
  const waiting = [...new Set(waitlistEntries.filter(e=>e.status==='waiting').map(e=>e.productId||e.product))];
  const invEl = document.getElementById('inv-list');
  if(!waiting.length){ if(invEl) invEl.innerHTML='<div class="loading-msg">No products on waitlist.</div>'; return; }
  if(invEl) invEl.innerHTML='<div class="loading-msg">Checking Shopify inventory…</div>';
  try{
    const data = await callClaude(
      `Use the Shopify MCP to check current inventory levels for these products: ${JSON.stringify(waiting)}.
Return ONLY a JSON array, no markdown:
[{"product_id":"p1","title":"Product Name","inventory_quantity":3}]`,
      [{type:"url", url:SHOPIFY_MCP, name:"shopify"}]
    );
    let inv = extractJSON(data);
    if(!inv||!Array.isArray(inv)) inv = waiting.map(p=>({
      product_id:p,
      title:waitlistEntries.find(e=>e.productId===p||e.product===p)?.product||p,
      inventory_quantity:0
    }));
    processInventory(inv);
  }catch(e){
    console.error("Inventory",e);
    if(invEl) invEl.innerHTML='<div class="loading-msg">Could not reach Shopify. Try again.</div>';
  }
}

function processInventory(inv){
  inv.forEach(item=>{
    if(item.inventory_quantity>0){
      waitlistEntries.forEach(async e=>{
        if((e.productId===item.product_id||e.product===item.title)&&e.status==='waiting'){
          e.status='available';
          await sheetsUpdate(e.customerName,e.product,'available');
        }
      });
    }
  });
  renderWaitlist();
  const invEl = document.getElementById('inv-list');
  if(!invEl) return;
  invEl.innerHTML = inv.map(item=>{
    const qty = item.inventory_quantity||0;
    const cls = qty===0?'inv-out':qty<=2?'inv-low':'inv-available';
    const label = qty===0?'Out of stock':qty<=2?`Low — ${qty}`:qty+' in stock';
    const waiters = waitlistEntries.filter(e=>e.productId===item.product_id||e.product===item.title);
    return `<div class="inv-row">
      <span class="inv-product">${item.title}</span>
      <span style="font-size:12px;color:var(--text3)">${waiters.length} waiting</span>
      <span class="inv-qty ${cls}">${label}</span>
      ${qty>0?'<span class="badge badge-green">🌸 Alert sent</span>':''}
    </div>`;
  }).join("") || '<div class="loading-msg">No waitlisted products found.</div>';
}

// ─── Schedule (Gusto) ─────────────────────────────────────────────────────────
async function loadSchedule(){
  const grid = document.getElementById('sched-grid');
  const highlights = document.getElementById('sched-highlights');
  if(grid) grid.innerHTML='<div style="padding:20px;color:var(--text3);font-size:13px;grid-column:1/-1">Loading schedule from Gusto…</div>';
  try{
    const data = await callClaude(
      `Use the Gusto MCP to fetch this week's employee work schedule and shifts.
IMPORTANT: Do NOT return any compensation, pay rates, salaries, or payroll data. Shifts only.
Return ONLY a JSON array, no markdown:
[{"employee":"Jane Smith","date":"2026-06-02","day":"Mon","start":"9:00 AM","end":"5:00 PM","location":"MKT Heights","type":"shift"},
{"employee":"All Staff","date":"2026-06-02","day":"Mon","start":"9:00 AM","end":"9:30 AM","location":"All","type":"meeting","title":"Team standup"}]`,
      [{type:"url", url:GUSTO_MCP, name:"gusto"}]
    );
    const am = data.content.filter(b=>b.type==="text").map(b=>b.text).join("\n").match(/\[[\s\S]{2,}\]/);
    let events = null;
    if(am){try{events=JSON.parse(am[0]);}catch{}}
    if(!events) events = extractJSON(data);
    if(events&&Array.isArray(events)&&events.length) renderScheduleWithData(events);
    else renderScheduleEmpty();
  }catch(e){ console.error("Schedule",e); renderScheduleEmpty(); }
}

function getWeekDays(){
  const now = new Date();
  const mon = new Date(now);
  mon.setDate(now.getDate()-((now.getDay()+6)%7));
  return Array.from({length:5},(_,i)=>{
    const d=new Date(mon); d.setDate(mon.getDate()+i);
    return {label:d.toLocaleDateString("en-US",{weekday:"short"})+" "+d.getDate(), date:d.toISOString().slice(0,10)};
  });
}

function renderScheduleWithData(events){
  const days  = getWeekDays();
  const times = ["8 AM","9 AM","10 AM","11 AM","12 PM","2 PM","4 PM"];
  const tKey  = {"8 AM":"8","9 AM":"9","10 AM":"10","11 AM":"11","12 PM":"12","2 PM":"14","4 PM":"16"};
  const cellMap = {};
  events.forEach(ev=>{
    const di = days.findIndex(d=>d.date===ev.date||d.label.toLowerCase().startsWith((ev.day||"").slice(0,3).toLowerCase()));
    if(di<0) return;
    const h = parseInt((ev.start||"9").replace(/[^0-9]/g,""));
    const k = h>=16?"16":h>=14?"14":h>=12?"12":String(h);
    const ck = k+"-"+di;
    if(!cellMap[ck]) cellMap[ck]=[];
    const cls = ev.type==="meeting"?"ev-rose":
      (ev.location||"").toLowerCase().includes("height")?"ev-sage":
      (ev.location||"").toLowerCase().includes("bellair")?"ev-blush":"ev-warm";
    cellMap[ck].push({cls, label:ev.title||(ev.type==="shift"?ev.employee+" shift":ev.employee)});
  });
  const grid = document.getElementById('sched-grid');
  if(!grid) return;
  let h = `<div class="sched-th"></div>${days.map(d=>`<div class="sched-th">${d.label}</div>`).join("")}`;
  times.forEach(t=>{
    const k=tKey[t];
    h+=`<div class="sched-time">${t}</div>`;
    for(let d=0;d<5;d++){
      const evs=cellMap[k+"-"+d]||[];
      h+=`<div class="sched-cell">${evs.map(e=>`<div class="ev ${e.cls}">${e.label}</div>`).join("")}</div>`;
    }
  });
  grid.innerHTML=h;
  const byDay={};
  events.forEach(ev=>{ const d=ev.day||""; if(!byDay[d])byDay[d]=[]; byDay[d].push(ev.title||ev.employee||(ev.type==="shift"?"Shift":"Event")); });
  const hl = document.getElementById('sched-highlights');
  if(hl) hl.innerHTML=Object.entries(byDay).slice(0,5).map(([day,evs])=>`
    <div style="display:flex;align-items:center;gap:10px;padding:9px 0;border-bottom:1px solid var(--border)">
      <span style="font-size:12px;font-weight:500;color:var(--text3);font-family:var(--mono);min-width:36px">${day.slice(0,3)}</span>
      <div class="ev ev-sage" style="margin:0;flex:1">${evs.join(" · ")}</div>
    </div>`).join("");
}

function renderScheduleEmpty(){
  const days  = getWeekDays();
  const times = ["8 AM","9 AM","10 AM","11 AM","12 PM","2 PM","4 PM"];
  const grid  = document.getElementById('sched-grid');
  if(!grid) return;
  let h = `<div class="sched-th"></div>${days.map(d=>`<div class="sched-th">${d.label}</div>`).join("")}`;
  times.forEach(t=>{
    h+=`<div class="sched-time">${t}</div>`;
    for(let d=0;d<5;d++) h+=`<div class="sched-cell"></div>`;
  });
  grid.innerHTML=h;
  const hl=document.getElementById('sched-highlights');
  if(hl) hl.innerHTML='<div style="color:var(--text3);font-size:13px;padding:8px 0">No shifts found in Gusto for this week.</div>';
}

// ─── Projects ─────────────────────────────────────────────────────────────────
function renderProjects(){
  const taskHtml=(task,col,i,isDone)=>`<div class="task" style="opacity:${isDone?.6:1}">
    <div class="task-title">${task.title}</div>
    <div style="font-size:11px;color:var(--text3);margin-bottom:8px">${task.who&&task.who!=="—"?task.who:"Unassigned"}${task.due&&task.due!=="TBD"?" · "+task.due:""}</div>
    <div class="task-footer">
      <div style="display:flex;gap:4px">
        ${!isDone?`<button class="btn btn-sm" onclick="moveTask('${col}',${i},'${col==='todo'?'inprogress':'done'}')" style="font-size:11px;padding:3px 7px">${col==='todo'?'→ Start':'→ Done'}</button>`:''}
        ${isDone?`<button class="btn btn-sm" onclick="moveTask('${col}',${i},'todo')" style="font-size:11px;padding:3px 7px">↩ Reopen</button>`:''}
      </div>
      <button class="btn btn-sm" onclick="deleteTask('${col}',${i})" style="font-size:11px;padding:3px 7px;color:var(--text3)">✕</button>
    </div></div>`;
  const cols={todo:'col-todo',inprog:'col-inprog',done:'col-done'};
  Object.entries(cols).forEach(([col,elId])=>{
    const el=document.getElementById(elId);
    if(!el) return;
    el.innerHTML=TASKS[col].length
      ? TASKS[col].map((t,i)=>taskHtml(t,col,i,col==='done')).join("")
      : `<div class="loading-msg">${col==='todo'?'No tasks — add one above':col==='inprog'?'None in progress':'None done yet'}</div>`;
  });
  const setEl=(id,v)=>{ const el=document.getElementById(id); if(el) el.textContent=v; };
  setEl('cnt-todo',   TASKS.todo.length);
  setEl('cnt-inprog', TASKS.inprog.length);
  setEl('cnt-done',   TASKS.done.length);
  const open=TASKS.todo.length+TASKS.inprog.length;
  setEl('open-count',       open+' open');
  setEl('done-count-badge', TASKS.done.length+' done');
}

async function addTask(){
  const title=prompt("Task title?"); if(!title) return;
  const who=prompt("Assigned to (name or initials)?")||"—";
  const due=prompt("Due date? (e.g. Jun 15, or leave blank)")||"";
  const task={title,who,due,status:"todo",added:new Date().toLocaleDateString("en-US",{month:"short",day:"numeric"})};
  TASKS.todo.unshift(task);
  renderProjects();
  await saveTask(task,"add");
}

// ─── Boot ─────────────────────────────────────────────────────────────────────
async function loadAll(){
  const dateEl=document.getElementById('dash-date'); if(dateEl) dateEl.textContent=today();
  renderGoals(); renderDashGoals(); renderProjects();
  renderScheduleEmpty(); // show blank grid immediately
  const wlBody=document.getElementById('wl-body');
  if(wlBody) wlBody.innerHTML='<tr><td colspan="6" style="text-align:center;color:var(--text3);padding:28px;font-size:13px">Loading from Google Sheets…</td></tr>';

  await Promise.all([
    loadOrders(),
    loadCustomers(),
    loadProducts(),
    sheetsGet(),
    loadGoals().then(()=>{ renderGoals(); renderDashGoals(); }),
    loadTasks(),
    loadSchedule()
  ]);

  // Auto-refresh
  setInterval(sheetsGet, 60*1000);
  setInterval(checkInventory, 30*60*1000);
}

window.loadAll = loadAll;